import { render } from "./ChatRoomManager.vue?vue&type=template&id=19103769&scoped=true"
import script from "./ChatRoomManager.vue?vue&type=script&lang=js"
export * from "./ChatRoomManager.vue?vue&type=script&lang=js"

import "./ChatRoomManager.vue?vue&type=style&index=0&id=19103769&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19103769"]])

export default __exports__